import MuiInputLabel, { InputLabelProps } from "@mui/material/InputLabel";

const InputLabel: React.FC<InputLabelProps> = MuiInputLabel;

export default InputLabel;

export type { InputLabelProps };
